document.addEventListener('DOMContentLoaded', function () {
  function initMegaMenuAccordion(root = document) {
    root.querySelectorAll('.mega-menu__accordion').forEach((accordion) => {
      accordion.addEventListener('click', (e) => {
        const heading = e.target.closest('.mega-menu__accordion-heading');
        if (!heading) return;

        // Find parent item
        const item = heading.closest('.mega-menu__accordion-item');
        const panel = item.querySelector('.mega-menu__accordion-panel');
        const isOpen = panel && !panel.hasAttribute('hidden');

        // If heading is an anchor, and panel is closed, prevent navigation and open instead.
        const isAnchor = heading.tagName === 'A';
        if (isAnchor && !isOpen) {
          e.preventDefault();
        }
         const isFirstItem = item.dataset.megaMenuTabId === '1';

        // Close all items
        accordion.querySelectorAll('.mega-menu__accordion-item').forEach((it) => {
          if (it.dataset.megaMenuTabId === '1') return; // Skip first item
          const p = it.querySelector('.mega-menu__accordion-panel');
          const h = it.querySelector('.mega-menu__accordion-heading');
          if (p && h) {
            p.setAttribute('hidden', '');
            h.setAttribute('aria-expanded', 'false');
            it.classList.remove('mega-menu__accordion-item--open');
          }
        });

        // Toggle clicked
        if (panel && !isOpen) {
          panel.removeAttribute('hidden');
          heading.setAttribute('aria-expanded', 'true');
          item.classList.add('mega-menu__accordion-item--open');
        } else if (isAnchor && isOpen) {
          // If anchor was clicked while already open, allow navigation (do nothing)
        }
      });

      // keyboard: open/close with Enter/Space when focused
      accordion.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          const heading = e.target.closest('.mega-menu__accordion-heading');
          if (heading) {
            e.preventDefault();
            heading.click();
          }
        }
      });
    });
  }

  initMegaMenuAccordion();

  // Re-init when sections load (Shopify theme editor)
  document.addEventListener('shopify:section:load', (e) => initMegaMenuAccordion(e.target));
});
